module.exports = __webpack_public_path__ + "img/equipos-moviles-img-4.58650c90.jpg";